/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import _ from 'lodash';
import {configureAdminResourceStates} from '../../common/controller/admin-resource-routing';
import {UserCopyModalComponent} from './user-copy-modal.component';
import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {UserResource} from '../../../components/api/resources/resource/user.resource';



export function userStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('users.user', UserResource, 'app.adm', 'app/admin');

        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'User',
          editTag: 'adn-user-edit-page',
          listTag: 'adn-user-list-page',
          listData: {
            app: ['ADVERTISING', 'DATA', 'POLITICAL']
          },
          itemData: {
            app: ['ADVERTISING', 'DATA', 'POLITICAL']
          },
          listResolve: {
            orderByParam: function() {
              return 'username';
            },
            readOnly: /*@ngInject*/ function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasNetwork(PERMISSIONS.manageSystem.apiKey)
                && !LocalUserPermissions.hasDataNetworkPermission(PERMISSIONS.dataAdmin.apiKey)
                && !LocalUserPermissions.hasNetwork(PERMISSIONS.axPublisherAdmin.apiKey)
                && !LocalUserPermissions.hasNetwork(PERMISSIONS.axAdvertiserAdmin.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.axPublisherTeamAdmin.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiserTeamAdmin.apiKey)
                && !LocalUserPermissions.hasNetwork(PERMISSIONS.selfServiceUserAdmin.apiKey)
                && !LocalUserPermissions.hasNetworkPermission('POLITICAL_ADMIN', null, 'POLITICAL');
            },
            extension: /*@ngInject*/ function() {
              const localUserProfile = adnRouterHelper.services.localUserProfile();
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return {
                func: function(ctrl) {
                  ctrl.currentUser = localUserProfile.get('username');

                  const networkId = LocalNetworkProfile.getNetworkId();
                  _.forEach(ctrl.items, function(item) {
                    item.inNetwork = LocalUserPermissions.userPartOf(item, networkId);
                    item.obfuscated = item.username.indexOf('@') < 0 && item.username.indexOf('*') > 0;

                    const roles = _.find(_.get(item, ['userRoles', 'rolesByNetwork']), function(rbn) {
                      return _.get(rbn, ['network', 'id']) === LocalNetworkProfile.get('networkId');
                    });
                    const roleEntries = _.get(roles, 'roles');
                    item.networkRole = _.filter(roleEntries, function(r) {
                      return !r.team;
                    });
                    item.teamRoles = _.filter(roleEntries, function(r) {
                      return r.team;
                    });
                    item.teamGroupRoles = _.filter(_.get(item, ['networkRole']), function(r) {
                      return r.teamGroup;
                    });
                  });
                }
              };
            }
          },
          itemResolve: {
            blockDelete: /*@ngInject*/ function(model) {
              const localUserProfile = adnRouterHelper.services.localUserProfile();

              if (model.id === localUserProfile.get('userId')) {
                return 'Cannot archive or delete yourself from the system.';
              }
              return model.username === 'adnuntius@adnuntius.com'
                && localUserProfile.get('username') !== 'adnuntius@adnuntius.com';
            },
            copyConfig: function() {
              return {
                modalComponent: UserCopyModalComponent,
                stateUrl: 'app.adm.users.user',
                lcase: 'user',
                ucase: 'User'
              };
            }
          }
        });
  }, adnRouterHelper);
}
